module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tag', {
    attrs: {
      "type": _vm.labelType
    }
  }, [_vm._v(_vm._s(_vm.statusName))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36b171cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/registration/components/StatusLabel.vue
// module id = 741
// module chunks = 2